import type { FC, PropsWithChildren } from 'react';
import React, { useContext } from 'react';

import { FlexItem } from '../../../Flex';
import {
  useIsLeftNavForcedCollapsedAtCurrentWidth,
  useIsLeftNavSuppressedAtCurrentWidth,
  useLeftNavWidth,
} from '../../hooks';

import { useClassNames } from './LeftNavContainer.styles';
import { LeftNavWidthOverrideContext } from './LeftNavWidthOverrideContext';

interface LeftNavContainerProps {
  readonly contentHeight?: number;
}

const LeftNavContainer: FC<PropsWithChildren<LeftNavContainerProps>> = ({ children, contentHeight }) => {
  const responsiveWidth = useLeftNavWidth();
  const overrideWidth = useContext(LeftNavWidthOverrideContext);
  const isForcedCollapsed = useIsLeftNavForcedCollapsedAtCurrentWidth();
  const width = isForcedCollapsed ? responsiveWidth : (overrideWidth ?? responsiveWidth);
  const isSuppressedAtCurrentWidth = useIsLeftNavSuppressedAtCurrentWidth();
  const classNames = useClassNames();

  if (isSuppressedAtCurrentWidth) {
    return null;
  }

  return (
    <FlexItem width={width} shrink={0} height="100%" className={classNames.leftNavContainer}>
      <div style={{ height: contentHeight }}>{children}</div>
    </FlexItem>
  );
};

export default LeftNavContainer;
